import { j as t } from "./jsx-runtime-944c88e2.js";
import { Box as d, Text as e, Button as j } from "@chakra-ui/react";
import { u as f, T as r } from "./eMyAsurionProvider-d8e4d830.js";
import "@tanstack/react-query";
import "react";
import "./useAccount-2421e215.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/icons";
import "./features-d3d4bb45.js";
import "./providers-251f5186.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-bf220bf9.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "@emotion/styled";
const I = ({
  onClickCallback: m,
  onSkipClick: h,
  header: p,
  bodyText: n,
  tipText: a,
  btnLabel: s,
  // linkLabel,
  children: u,
  ...x
}) => {
  const i = "SubmitDeclaration", { data: l } = f(), { theme: c } = l, { colors: o } = c;
  return /* @__PURE__ */ t.jsxs(d, { ...x, marginTop: "1.5rem", children: [
    /* @__PURE__ */ t.jsx(e, { fontSize: "32px", children: /* @__PURE__ */ t.jsx(r, { text: p, translationKey: `${i}/header` }) }),
    /* @__PURE__ */ t.jsx(e, { fontSize: "18px", pt: "0.5rem", children: /* @__PURE__ */ t.jsx(r, { text: n, translationKey: `${i}/bodyText` }) }),
    /* @__PURE__ */ t.jsx(e, { fontSize: "14px", fontWeight: "bold", py: "1rem", children: /* @__PURE__ */ t.jsx(r, { text: a, translationKey: `${i}/tipText` }) }),
    /* @__PURE__ */ t.jsx(
      j,
      {
        variant: "outline",
        onClick: () => {
          m && m("");
        },
        display: "flex",
        justifyContent: "center",
        marginX: "auto",
        bg: o == null ? void 0 : o.primary,
        textColor: "white",
        width: { base: "full", lg: "50%" },
        mt: { base: "0.5rem", lg: "1rem" },
        children: /* @__PURE__ */ t.jsx(r, { text: s, translationKey: `${i}/btnLabel` })
      }
    )
  ] });
};
export {
  I as SubmitDeclaration
};
